

import './update-password.component.js';
import './update-password.controller.js';
import './update-password.service.js';

angular
.module('inkfinder')
.config(function($stateProvider) {
  $stateProvider
  .state('inkfinder.collector.password', {
    url: '/password',
    views: {
      'base@inkfinder.collector': {
        component: 'inkCollectorUpdatePassword'
      }
    },
    resolve: {
      $title: (() => 'Update your password')
    }
  });
});



// WEBPACK FOOTER //
// ./components/collector/update-password/index.js